<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo != ''" class="slider-area topo-cel">
    <div class="slider-height2 slider-bg4 hero-overly d-flex align-items-center"
      :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-6 col-md-6">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  final banner -->

  <!--=== representante ==========-->
  <div v-if="representante != ''" class="our-services section-padding-rep position-relative">
    <div class="container">
      <div class="row justify-content-sm-center">
        <div class="col-md-11">
          <!-- Section Tittle -->
          <div class="section-tittle text-center mb-70">
            <h2>{{ representante[0].itiNome }}</h2>
            <p v-html="representante[0].itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- final representante -->

  <!-- final missao -->

  <PageCallAction></PageCallAction>

</template>

<script>
import PageCallAction from '../components/PageCallAction.vue'
import { useHead } from '@vueuse/head'
import axios from 'axios'

export default {
  name: 'RepresentanteView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
     representante: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    // bannerTopo
    axios.get('/Process/InsInstitucional/institucional/50/representantetopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas("", this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });


    // representante
    axios.get('/Process/InsInstitucional/institucional/49/representante/0/x')
      .then(response => {
        this.representante = response.data;
        //console.log('representante')
        //console.log(this.representante)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>